"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const openapi_1 = require("./openapi");
const base_api_1 = require("./base_api");
const toolbox_1 = require("@streem/toolbox");
class StreemAPI {
    configure({ apiUrl, tokenFetcher }, openApiConfig) {
        this.base = new base_api_1.BaseApi(apiUrl, tokenFetcher, openApiConfig);
    }
    setShareToken(token) {
        (0, toolbox_1.invariant)(this.base, 'StreemAPI.configure must be called first');
        this.base.setShareToken(token);
    }
    setAdminBearerToken(token) {
        (0, toolbox_1.invariant)(this.base, 'StreemAPI.configure must be called first');
        this.base.setAdminBearerToken(token);
    }
    setApiKey(id, secret) {
        (0, toolbox_1.invariant)(this.base, 'StreemAPI.configure must be called first');
        this.base.setApiKey(id, secret);
    }
    get configuration() {
        (0, toolbox_1.invariant)(this.base, 'StreemAPI.configure must be called first');
        return new openapi_1.Configuration(this.base.apiConfig);
    }
    get analytics() {
        var _a;
        (0, toolbox_1.invariant)(this.base, 'StreemAPI.configure must be called first');
        const analyticsApiConfig = Object.assign(Object.assign({}, this.base.apiConfig), { middleware: [
                ...((_a = this.base.apiConfig.middleware) !== null && _a !== void 0 ? _a : []),
                // Mark all analytics requests as keepalive (send even after page is closed)
                {
                    pre: (event) => __awaiter(this, void 0, void 0, function* () {
                        event.init.keepalive = true;
                        return event;
                    }),
                },
            ] });
        const analyticsConfig = new openapi_1.Configuration(analyticsApiConfig);
        return new openapi_1.Analytics.AnalyticsApi(analyticsConfig);
    }
    get apps() {
        (0, toolbox_1.invariant)(this.base, 'StreemAPI.configure must be called first');
        return new openapi_1.Apps.AppsApi(this.configuration);
    }
    get auth() {
        (0, toolbox_1.invariant)(this.base, 'StreemAPI.configure must be called first');
        return new openapi_1.Auth.AuthApi(this.configuration);
    }
    get authLogin() {
        (0, toolbox_1.invariant)(this.base, 'StreemAPI.configure must be called first');
        return new openapi_1.AuthLogin.AuthLoginApi(this.configuration);
    }
    get centralLogin() {
        (0, toolbox_1.invariant)(this.base, 'StreemAPI.configure must be called first');
        return new openapi_1.CentralLogin.CentralLoginApi(this.configuration);
    }
    get companies() {
        (0, toolbox_1.invariant)(this.base, 'StreemAPI.configure must be called first');
        return new openapi_1.Companies.CompaniesApi(this.configuration);
    }
    get countries() {
        (0, toolbox_1.invariant)(this.base, 'StreemAPI.configure must be called first');
        return new openapi_1.Countries.CountriesApi(this.configuration);
    }
    get downloads() {
        (0, toolbox_1.invariant)(this.base, 'StreemAPI.configure must be called first');
        return new openapi_1.Downloads.DownloadsApi(this.configuration);
    }
    get default() {
        (0, toolbox_1.invariant)(this.base, 'StreemAPI.configure must be called first');
        return new openapi_1.Default.DefaultApi(this.configuration);
    }
    get devices() {
        (0, toolbox_1.invariant)(this.base, 'StreemAPI.configure must be called first');
        return new openapi_1.Devices.DevicesApi(this.configuration);
    }
    get groups() {
        (0, toolbox_1.invariant)(this.base, 'StreemAPI.configure must be called first');
        return new openapi_1.Groups.GroupsApi(this.configuration);
    }
    get images() {
        (0, toolbox_1.invariant)(this.base, 'StreemAPI.configure must be called first');
        return new openapi_1.Images.ImagesApi(this.configuration);
    }
    get licenses() {
        (0, toolbox_1.invariant)(this.base, 'StreemAPI.configure must be called first');
        return new openapi_1.Licenses.LicensesApi(this.configuration);
    }
    get rooms() {
        (0, toolbox_1.invariant)(this.base, 'StreemAPI.configure must be called first');
        return new openapi_1.Rooms.RoomsApi(this.configuration);
    }
    get sso() {
        (0, toolbox_1.invariant)(this.base, 'StreemAPI.configure must be called first');
        return new openapi_1.Sso.SsoApi(this.configuration);
    }
    get loginIdentities() {
        (0, toolbox_1.invariant)(this.base, 'StreemAPI.configure must be called first');
        return new openapi_1.LoginIdentities.LoginIdentitiesApi(this.configuration);
    }
    get uploads() {
        (0, toolbox_1.invariant)(this.base, 'StreemAPI.configure must be called first');
        return new openapi_1.Uploads.UploadsApi(this.configuration);
    }
    get users() {
        (0, toolbox_1.invariant)(this.base, 'StreemAPI.configure must be called first');
        return new openapi_1.Users.UsersApi(this.configuration);
    }
    get tags() {
        (0, toolbox_1.invariant)(this.base, 'StreemAPI.configure must be called first');
        return new openapi_1.Tags.TagsApi(this.configuration);
    }
    get terms() {
        (0, toolbox_1.invariant)(this.base, 'StreemAPI.configure must be called first');
        return new openapi_1.Terms.TermsApi(this.configuration);
    }
    get webhooks() {
        (0, toolbox_1.invariant)(this.base, 'StreemAPI.configure must be called first');
        return new openapi_1.Webhooks.WebhooksApi(this.configuration);
    }
}
// This is a singleton, default export is valid here.
// eslint-disable-next-line import/no-default-export
exports.default = new StreemAPI();
//# sourceMappingURL=streem_api.js.map